import React, { useState } from "react";
import { Popover, PopoverBody } from "reactstrap";

import { capitalizeUpperCases } from "@/utils/common-functions";
type Props = {
  rate: any;
  service: any;
  account: any;
  onlyRate?: boolean;
  carrierName: string;
  id: string;
  noRate?: boolean;
  children?: any;
};

const RateDetailsPopover = ({
  rate,
  onlyRate,
  account,
  service,
  carrierName,
  id,
  noRate,
  children,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const addTaxes = () => {
    let tax = 0;
    rate.taxes?.forEach((t: any) => {
      tax += t.amount;
    });
    return tax;
  };

  return (
    <div
      id={id}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      className="pointer"
    >
      <>{!noRate ? `${rate.currency}$ ${rate.totalCharge}` : children}</>
      <Popover
        target={id}
        isOpen={isOpen}
        placement="left"
        toggle={() => setIsOpen((s) => !s)}
      >
        <PopoverBody>
          <table>
            <tbody>
              {onlyRate ? (
                <></>
              ) : (
                <>
                  <tr>
                    <td>Account</td>
                    <td>{account?.name}</td>
                  </tr>
                  <tr>
                    <td>Carrier</td>
                    <td>
                      {service.serviceName !== "SV Big Savings"
                        ? carrierName
                        : "SV Select"}
                    </td>
                  </tr>
                  <tr>
                    <td>Service</td>
                    <td>{service.serviceName}</td>
                  </tr>
                </>
              )}
              {service.subservices && (
                <tr>
                  <td>Sub Services</td>
                  <td>
                    {service.subservices.map((sub: any, i: number) => (
                      <div key={i}>{sub.serviceName}</div>
                    ))}
                  </td>
                </tr>
              )}
              <tr>
                <td>Base</td>
                <td>${rate.baseCharge}</td>
              </tr>
              {carrierName === "UPS"
                ? null
                : rate?.adjustments?.map((adjustment: any, i: number) => (
                    <tr key={`adjustment${i}`}>
                      <td>{adjustment.name}</td>
                      <td>${adjustment.amount}</td>
                    </tr>
                  ))}
              {carrierName === "UPS"
                ? null
                : rate?.additionalCharges?.map((addition: any, i: number) => (
                    <tr key={`addition${i}`}>
                      <td>{capitalizeUpperCases(addition.name)}</td>
                      <td>${addition.amount}</td>
                    </tr>
                  ))}
              <tr>
                <td>Tax</td>
                <td>${addTaxes()}</td>
              </tr>
              {rate.optionsCharge ? (
                rate.optionsCharge.map((option: any, i: number) => (
                  <tr key={`optionCharge${i}`}>
                    {option.amount !== 0 ? (
                      <>
                        <td>{option.name}</td>
                        <td>${option.amount}</td>
                      </>
                    ) : (
                      <></>
                    )}
                  </tr>
                ))
              ) : (
                <></>
              )}
              <tr>
                <td>Total</td>
                <td>${rate.totalCharge}</td>
              </tr>
            </tbody>
          </table>
        </PopoverBody>
      </Popover>
    </div>
  );
};

export default RateDetailsPopover;
